import { BaseDataItem, Component, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { createCompNode, NodeRefs } from '@wix/thunderbolt-catharsis'
import { PresetsDataList } from './types'
import { isRefArray, isPresetDataItem, isPresetVariantRelation } from '@wix/thunderbolt-catharsis-extensions'

const isBuilderCompData = (comp: Component, compData: BaseDataItem): compData is WidgetRefDataItem =>
	comp.componentType === 'BuilderComponent'

const getUsedPresetsIds = (compPresets: BaseDataItem) => {
	const presetsRefArray = isRefArray(compPresets) ? compPresets.values : [compPresets]
	return presetsRefArray.map((presetVariant) =>
		isPresetDataItem(presetVariant)
			? presetVariant.style
			: isPresetVariantRelation(presetVariant)
			? presetVariant.to.style
			: ''
	)
}

export const presetIdsNode = createCompNode({
	getDependencies: (component: Component, refs: NodeRefs<{}>) => ({
		compPresets: refs.presetsQuery(component.presetsQuery!),
		compData: refs.dataQuery(component.dataQuery!),
	}),
	toViewItem: (comp, { compPresets, compData }) => {
		if (!isBuilderCompData(comp, compData)) {
			return
		}
		const { widgetId, appDefinitionId } = compData
		const presets = getUsedPresetsIds(compPresets)

		return presets.map((presetId) => ({
			widgetId,
			appDefinitionId,
			presetId,
		})) as PresetsDataList
	},
})
